module.exports = __webpack_public_path__ + "img/marker.2cb7b8a7.svg";